import React from 'react';
import { Typography } from '@mui/material';

export default (
  {
    charts = [],
    style = { width: '100%', height: '500px' },
    label = '',
    className = '',
  },
) => (
  <div className={className} style={{ ...style, paddingTop: '15px', paddingBottom: '25px' }}>
    <Typography variant="h5" component="h2" style={{ textAlign: 'center', paddingBottom: '10px', fontSize: '15px' }}>{label}</Typography>
    {
      charts.map((chart, index) => {
        const ChartComponent = chart.component;
        return (
          <div key={index} className="chartContainer">
            {
              chart.component ? <ChartComponent {...chart} /> : chart
            }
          </div>
        );
      })
    }
  </div>
);
